import request from "@/utils/request";
import cookies from "js-cookie";
// import checkThereIsQuery from "@/helpers/checkQuery";
const localeCookie = cookies.get("language");
export function index(reqName, query = {}, locale = localeCookie) {
  return request({
    url: `api/admin/${reqName}`,
    headers: { "X-locale": locale },
    method: "get",
    params: {
      ...query
    }
  });
}

export function showData(reqName, param, locale = localeCookie, query = {}) {
  return request({
    url: `api/admin/${reqName}/${param}`,
    headers: { "X-locale": locale },
    method: "get",
    params: {
      ...query
    }
  });
}

export function storeData(reqName, data) {
  return request({
    url: `api/admin/${reqName}`,
    method: "post",
    data
  });
}
export const updateData = (reqName, data, param, locale = localeCookie) => {
  return request({
    url: `api/admin/${reqName}/${param}`,
    method: "post",
    headers: { "X-locale": locale },
    data
  });
};
export function deleteData(reqName, param) {
  return request({
    url: `api/admin/${reqName}/${param}`,
    method: "delete"
  });
}
export function mediaUpdate(param, data) {
  return request({
    url: `api/admin/media/${param}`,
    method: "post",
    data
  });
}

export function deleteMedia(param) {
  return request({
    url: `/api/media/${param}`,
    method: "delete"
  });
}
